import Data from '../Data.mjs';

export const dataPriv = new Data();

export const dataUser = new Data();
